import React, { createContext, useContext, useReducer} from "react"

// prep data layer

export const StateContext = createContext();

export const StateProvider = ({ reducer, initialState, children
}) => (
    <StateContext.Provider value={useReducer(reducer,
        initialState)}>
            {children}
        </StateContext.Provider>
);
// hook that pulls info from datas layer
export const useStateValue = () => useContext(StateContext);